import { Component, ElementRef } from '@angular/core';
import { BaseView } from '@wizeoo/akm-common-lib';

/**
 * Vue d'acceuil de la gestion des données dans une bu
 */
@Component({
  selector: 'dashboard-data-view',
  templateUrl: './dashboard-data.view.html',
})
export class DashboardDataView extends BaseView {
  
  /**
   * Constructeur
   * @param elementRef elementRef pour pose d'écouteurs
   */
  constructor(public elementRef: ElementRef) {
    super(elementRef);
  }
}
